import { formatedPhoneNumber, unformatedPhoneNumber } from './phoneFormatter';

export default {
  displayFormat(value) {
    const numberLength = 11;
    const mask = '+__-___-___-___';
    return formatedPhoneNumber(value, mask, numberLength);
  },
  modelFormat(valueToFormat) {
    const value = unformatedPhoneNumber(valueToFormat);
    return value;
  },
};
